import queryString from "query-string";
import pickBy from "lodash/pickBy";
import isEmpty from "lodash/isEmpty";
import identity from "lodash/identity";
import map from "lodash/map";
import assign from "lodash/assign";
import omit from "lodash/omit";
import flattenDeep from "lodash/flattenDeep";
import union from "lodash/union";

import "moment/locale/de";
import "moment/locale/es-us";

export const buildUrl = ({ path, urlParameters = [], queryParameters = {}, props = {} }) => {
    let url = path;

    urlParameters = urlParameters.filter(parameter => Boolean(parameter));
    queryParameters = pickBy(queryParameters, value => value !== null && value !== undefined);
    if (urlParameters.length > 0) url += `/${urlParameters.join("/")}`;

    if (!isEmpty(queryParameters))
        url += `?${queryString.stringify(queryParameters, {
            sort: false,
            arrayFormat: props.arrayFormat ?? "bracket-separator"
        })}`;

    return url;
};

export const getQueryParameters = (location, defaultValue) => {
    const result = queryString.parse(location?.search, {
        arrayFormat: "bracket-separator",
        parseNumbers: true,
        parseBooleans: true
    });

    return result ?? defaultValue;
};

export const getQueryParameter = (location, parameterName, defaultValue) => {
    const result = queryString.parse(location?.search, {
        arrayFormat: "bracket-separator",
        parseNumbers: true,
        parseBooleans: true
    })[parameterName];

    return result ?? defaultValue;
};

export const flattenTree = (tree, key) => {
    function recurse(nodes, path) {
        return map(nodes, function (node) {
            var newPath = union(path, [node.name]);
            return [
                assign(
                    {
                        pathname: newPath.join(" > "),
                        level: path.length
                    },
                    omit(node, key)
                ),
                recurse(node[key], newPath)
            ];
        });
    }

    return flattenDeep(recurse(tree, []));
};

export const clearLocaleStorage = () => {
    localStorage.clear();
};

export const setLocalStorageItem = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
};

export const getLocalStorageItem = (key, defaultValue) => {
    return JSON.parse(localStorage.getItem(key)) ?? defaultValue;
};

export const generateRandomPassword = length => {
    const lowercase = "abcdefghijklmnopqrstuvwxyz";
    const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numbers = "0123456789";
    const special = "!@#$%^&*";

    // Ensure at least one of each required character type for streetscooter password policy
    const guaranteedChars = [
        lowercase[Math.floor(Math.random() * lowercase.length)],
        uppercase[Math.floor(Math.random() * uppercase.length)],
        numbers[Math.floor(Math.random() * numbers.length)],
        special[Math.floor(Math.random() * special.length)]
    ];

    const allChars = lowercase + uppercase + numbers + special;
    const remainingLength = length - guaranteedChars.length;
    const remainingChars = Array.from(crypto.getRandomValues(new Uint32Array(remainingLength))).map(x => allChars[x % allChars.length]);

    const combined = [...guaranteedChars, ...remainingChars];

    return combined.join("");
};
